import React, { Component } from 'react';
// import './App.css';
import products from './config/products.json';

class Calc extends Component {
  constructor(props){
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = { basic: 0 }
  }

  handleChange(e) {
    let basic = 0;
    if(e.target.value !== ""){
      basic = e.target.value;
    }
    this.setState({basic: parseFloat(basic)});
  }

  render() {
    const basic = this.state.basic;
    return (
      <div className="App">
        {/* <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Ganesh Steel & Alloys</h1>
        </header> */}
        <SearchBar handleChange={this.handleChange}/>
        <ProductCategory category="Angle"/>
        <ProductSection products={products.angle} basic={basic}/>
        <ProductCategory category="Flat" />
        <ProductSection products={products.flat} basic={basic}/>
        <ProductCategory category="Channels" />
        <ProductSection products={products.channels} basic={basic}/>
        <ProductCategory category="Squares" />
        <ProductSection products={products.square} basic={basic}/>
      </div>
    );
  }
}

class ProductCategory extends React.Component {
  render() {
    const category = this.props.category;
    return (
      <label>
        {category}
      </label>
    );
  }
}

class ProductSection extends React.Component {
  render(){
    const product = this.props.products;
    const basic = this.props.basic;
    const rows = [];
    product.forEach((product) => {
      rows.push(<ProductDetail product={product} key={product.size} basic={basic}/>);
    });
    return (
      <table className="calc">
        <thead>
          <tr>
            <th className="product-size">size</th>
            <th className="product-diff">difference</th>
            <th className="product-price">price</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    );
  }
}

class ProductDetail extends React.Component {
  render() {
    const product = this.props.product;
    const basic = parseFloat(this.props.basic);
    const price = basic === 0 ? "" : basic + product.difference;

    return (
      <tr>
        <td>{product.size}</td>
        <td>{product.difference}</td>
        <td>{price}</td>
      </tr>
    );
  }
}

class SearchBar extends React.Component {
  render() {
    return (
      <form>
        <input type="text"  className="search-bar" placeholder="Basic Price" onChange={this.props.handleChange}/>
      </form>
    );
  }
}

export default Calc;



// WEBPACK FOOTER //
// ./src/js/Calc.js